<template>
  <div class="honorary-award flex-box">
    <img v-lazy="ryjx" alt="" class="honorary-award-bj">
    <div class="honorary-award-title">荣誉奖项</div>
    <div class="honorary-award-description">行业的评价和口碑，我们最宝贵的资产</div>
    <div class="container">
      <div class="content-box">
        <div class="list-item" v-for="(item, k) in listData" :key="k">
          <img v-lazy="itembj" alt="">
          <div class="item-content1">{{ item.content1 }}</div>
          <div class="item-content2">{{ item.content2 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ryjx from '@/assets/images/ryjx.png'
import itembj from '@/assets/images/itembj.png'

export default {
  props: {
    
  },
  data() {
    return {
      itembj,
      ryjx,
      listData: [
        {
          content1: '2023年度智能研发解决方案优秀供应商',
          content2: '- 璞华科技有限公司 -',
        },
        {
          content1: '2023年度智能制造优秀推荐产品',
          content2: '- 璞华易研PLM -',
        },
        {
          content1: '2023国产PLM软件榜单',
          content2: '- 璞华易研PLM上榜 -',
        },
        {
          content1: '2024国产PLM软件榜单',
          content2: '- 璞华易研PLM上榜 -',
        },
        {
          content1: 'e-works 2023年度智能制造优秀供应商',
          content2: '- 璞华科技有限公司 -',
        },
        {
          content1: 'e-works 2023年度智能制造优秀推荐产品',
          content2: '- 璞华易研PLM -',
        }
      ]
    }
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.honorary-award {
  flex-direction: column;
  align-items: center;
  position: relative;
  .honorary-award-bj {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .honorary-award-title {
    padding: 9rem 0 2.4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 4rem;
    color: #333333;
    line-height: 4rem;
    text-align: center;
    font-style: normal;
    text-transform: uppercase;
  }

  .honorary-award-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 1.8rem;
    color: #666A77;
    line-height: 1.8rem;
    text-align: center;
    font-style: normal;
    padding-bottom: 10rem;
  }

  .container {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .content-box {
    position: relative;
    width: calc(192rem - 50rem);
    margin: 0 auto 4rem;
    overflow: hidden;

    .list-item {
      float: left;
      width: 68rem;
      height: 15rem;
      box-shadow: 0rem 0.5rem 4rem 0rem rgba(196,211,228,0.3);
      padding-top: 4.2rem;
      margin: 0rem 4rem 6rem 0;
      border-radius: 1.8rem;
      cursor: pointer;
      position: relative;
      text-align: center;
      img {
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        z-index: -1;
      }
      &:nth-child(even) {
        margin-right: 0;
      }
      .item-content1 {
        height: 2.6rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 2.6rem;
        color: #1485F6;
        line-height: 2.6rem;
        font-style: normal;
        margin-bottom: 1.6rem;
      }
      .item-content2 {
        height: 2.4rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 2.4rem;
        color: #333333;
        line-height: 2.4rem;
        text-align: center;
        font-style: normal;
      }
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .honorary-award {
    .content-box {
      width: 100%;
      padding: 0 1.6rem;
      overflow: visible;
      .list-item {
        float: none;
        width: 100%;
        height: auto;
        min-height: 0;
        margin: 0 0 1.6rem;
        padding: 2.4rem 1.6rem;
        img {
          object-fit: contain;
        }
        .item-content1,
        .item-content2 {
          height: auto;
          white-space: normal;
          word-break: break-word;
        }
        .item-content1 {
          font-size: 1.8rem;
          line-height: 2.6rem;
          margin-bottom: 0.8rem;
        }
        .item-content2 {
          font-size: 1.5rem;
          line-height: 2.2rem;
        }
      }
    }
  }
}
</style>
